export const PACKAGE_NAME = 'jira-plans-banners';
export const TEAM_NAME = 'growth-tako';
export const TRAIT_NAME = 'jira_premium_sample_project_id';
